import countries from 'i18n-iso-countries';
import deutsch from 'i18n-iso-countries/langs/de.json';
import english from 'i18n-iso-countries/langs/en.json';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useForm } from '../../../../lib/components';
import { useStore } from '../../../../hooks/useStore';
import { AddressDataView } from './view';
import { AddressDataForm } from './form';
import { ProfileViewEditBox } from '../shared/profileViewEditBox';

countries.registerLocale(deutsch);
countries.registerLocale(english);

export const EmployeeProfilAddressData = observer(() => {
  const { employeeStore } = useStore();
  const { employeeId } = useParams();
  const { t } = useTranslation();
  const form = useForm();
  const [canSubmit, setCanSubmit] = useState<boolean>(false);

  const renderView = observer(() => (
    <AddressDataView data={employeeStore.currentEmployee?.address} />
  ));

  const renderEdit = () => {
    return (
      <AddressDataForm
        initialValues={{
          street_name_and_number:
            employeeStore.currentEmployee?.address?.street_name_and_number || '',
          address_supplement: employeeStore.currentEmployee?.address?.address_supplement || '',
          zip_code: employeeStore.currentEmployee?.address?.zip_code || '',
          city: employeeStore.currentEmployee?.address?.city || '',
          province: employeeStore.currentEmployee?.address?.province || '',
          country: employeeStore.currentEmployee?.address?.country || '',
          missing_fields: employeeStore.currentEmployee?.address.missing_fields
        }}
        formRef={form.formRef}
        onStateChanged={setCanSubmit}
        onSubmit={async (values) => {
          try {
            if (employeeId) {
              await employeeStore.updateEmployeeAddressData(employeeId, values);
            }
          } catch (error) {
            console.error(error);
          }
        }}
      />
    );
  };

  return (
    <ProfileViewEditBox
      title={t('employee:ADDRESS')}
      view={renderView}
      edit={renderEdit}
      canEdit
      canSubmit={canSubmit}
      onSubmit={form.handleSubmit}
      onCancel={form.handleReset}
    />
  );
});
